import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'usuarios/roles-usuarios';

/**
 * GET Usuarios activos de la entidad (datos mínimos para asignar roles)
 * @returns {Promise<Array<{id: number, nombre: string, email: string}>>}
 */
export const getUsuariosParaRoles = async () => {
  try {
    const response = await API.get(`${baseURI}/usuarios`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Ids de los usuarios que tienen asignado un rol
 * @param {number} rolId
 * @returns {Promise<number[]|null>} null si falla la consulta
 */
export const getUsuariosDeRol = async (rolId) => {
  try {
    const response = await API.get(`${baseURI}/${rolId}`);
    return response.data.usuarios;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * PATCH Reemplaza los usuarios asignados a un rol (agrega y quita)
 * @param {number} rolId
 * @param {number[]} usuarios
 * @returns {Promise<number[]|null>} ids guardados, null si falla
 */
export const patchUsuariosDeRol = async (rolId, usuarios) => {
  try {
    const response = await API.patch(`${baseURI}/${rolId}`, { usuarios });
    onSuccess(response, 'Usuarios del rol actualizados correctamente');
    return response.data.usuarios;
  } catch (err) {
    onError(err);
  }
  return null;
};
